var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [
        _vm._v(_vm._s(_vm.$ct("ledger-accounts-upload-csv-title"))),
      ]),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-card-content" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  !_vm.file
                    ? _c("app-file-upload", {
                        attrs: {
                          sending: _vm.isUploading,
                          "allowed-extensions": ["csv"],
                          label: _vm.$ct("csv-file"),
                        },
                        on: {
                          input: function ($event) {
                            return _vm.onFile($event)
                          },
                          error: function ($event) {
                            return _vm.onError($event)
                          },
                        },
                      })
                    : _c(
                        "div",
                        { style: { minHeight: "54px" } },
                        [
                          _vm._v(" " + _vm._s(_vm.file.name) + " "),
                          _c(
                            "w-link",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct("common.delete"),
                                  expression: "$ct('common.delete')",
                                },
                              ],
                              on: {
                                click: function ($event) {
                                  _vm.file = null
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "times" } })],
                            1
                          ),
                        ],
                        1
                      ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { disabled: _vm.cancelDisabled, icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              staticClass: "confirm",
              attrs: { disabled: _vm.confirmDisabled, icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }